var _g, _use, _use2, _use3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePictureMultipleImportable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 1044.362a2 2 0 01-2 2H7a2 2 0 01-2-2v-10a2 2 0 012-2h14a2 2 0 012 2v4z",
    fill: "#95a5a6",
    transform: "translate(3 -1051.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 1043.362a2 2 0 002 2h14a2 2 0 002-2v-10a2 2 0 00-2-2H7a2 2 0 00-2 2v4z",
    fill: "#bdc3c7",
    transform: "translate(3 -1051.362)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f39c12",
    d: "M7 1033.362h14v10H7z",
    transform: "translate(3 -1051.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.625 8.625L9 15h12v-2z",
    transform: "translate(3 -23)",
    fill: "#e67e22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 1036.362a2.5 2.5 0 11-5 0 2.5 2.5 0 115 0z",
    fill: "#f1c40f",
    strokeWidth: 1.75,
    transform: "translate(3 -1051.362)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1037.362l-3 3.188v2.812h10z",
    fill: "#d35400",
    transform: "translate(3 -1051.362)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#a",
    id: "b",
    transform: "translate(-2 20)",
    width: "100%",
    height: "100%"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(-3 4)",
    width: "100%",
    height: "100%"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "translate(-6 8)",
    width: "100%",
    height: "100%"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePictureMultipleImportable);
export default __webpack_public_path__ + "static/media/file-picture-multiple-importable.4393f4828bdfd0baaf375bc75eb77b4f.svg";
export { ForwardRef as ReactComponent };